import React from 'react';
import { Text } from '@ui-kitten/components';
import { View } from 'react-native';
import { BrandText } from '../../components/brandText';
import { useNavigation } from '@react-navigation/native';


export const PoweredByPoall = () => {
    const navigation = useNavigation();
    return (
        <View style={{ justifyContent: 'center', alignItems: 'center' }}>
            <Text appearance='hint'  onPress={() => navigation.navigate('Home')}>
                {'Powered by '}
                <BrandText status='primary' category='h5'>poall</BrandText>
            </Text>
        </View>
    );
};
